
$(document).ready(function() { 
    $(".footer-link").click(function(){
        // console.log($(this).children());
        $(this).children().toggleClass("show");
        $(this).find(".arrow-down").toggleClass("show-arrow");
        $(this).find(".arrow-up").toggleClass("show-arrow");
	});
});